import { message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  CurrencyManageTable,
  Icon,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { statusOptions } from "../options_common";

export const CurrencyManagement = () => {
  const [modal, setModal] = useState({
    edit: false,
    add: false,
    view: false,
  });
  const [editId, setEditedId] = useState();
  const [formData, setFormData] = useState({
    name: "",
    status: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [currencyMge, setCurrencyMge] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [, setDetails] = useState({});
  const [, setSelectedOption] = useState(null);
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getCurrencyMge();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({
      name: "",
      status: "",
    });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false });
    resetForm();
  };

  const getCurrencyMge = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/trcurrency?search=${search}`, {
        headers: authHeader(),
      });
      const { data } = await response.data;
      const resultData = data.body;
      if (resultData) {
        setCurrencyMge(resultData);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      // const message = error.response;
      setIsLoading(false);
    }
  };

  const addCurrencyMge = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/trcurrency`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getCurrencyMge();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        message.success({
          content: "Currency Created",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      getCurrencyMge();
      setModal({ add: false });
      resetForm();
      return { message };
    }
  };

  const editCurrencyMge = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/trcurrency/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getCurrencyMge();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        message.success({
          content: "Currency Updated",
          style: {
            marginTop: "20vh",
          },
        });
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      message.error({
        content: message.data.message,
        style: {
          marginTop: "20vh",
        },
      });
      resetForm();
      return { message };
    }
  };

  const deleteProductCat = async () => {
    try {
      setIsLoading(true);
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/admin/trcurrency/${formData.id}`, {
        headers: authHeader(),
      });

      const data = await response.data;
      if (data) {
        getCurrencyMge();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ delete: false });
        resetForm();
      }
      return { data };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      getCurrencyMge();
      setModal({ delete: false });
      resetForm();
      return { message };
    }
  };

  const onFormSubmit = () => {
    addCurrencyMge(formData);
    resetForm();
    // setModal({ add: false });
  };

  const onDeleteClick = (items) => {
    setModal({ delete: true });
    setFormData({
      id: items.id,
    });
  };

  const onEditSubmit = () => {
    editCurrencyMge(formData);
    resetForm();
    setModal({ edit: false });
  };

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      name: items.name,
      status: items.status,
      id: items.id,
    });
    setDetails(items);
    setEditedId(items.id);
    setSelectedOption({ value: items.status, label: items.status });
  };

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = currencyMge?.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    getCurrencyMge();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Currency Management" />
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">Currency Management</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search Currency..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_CURRENCY"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Add Currency</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <CurrencyManageTable
                currencyMge={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                handleView={() => setModal({ view: true })}
                handleEdit={() => setModal({ edit: true })}
                handleDel={onDeleteClick}
              />
            )}
          </Card>
          <div className="card-inner">
            {currencyMge && currencyMge.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={currencyMge.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No currency found</span>
              </div>
            )}
          </div>
        </Block>

        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add Currency</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Currency Name</label>
                      <input
                        type="text"
                        name="name"
                        // defaultValue={formData.name}
                        placeholder="Currency Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        onChange={(e) => onInputChange(e)}
                        ref={register({
                          required: "This field is required",
                        })}
                      >
                        <option></option>
                        <option value="ACTIVE">ACTIVE</option>.<option value="INACTIVE">INACTIVE</option>.
                      </select>
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                      {/* <label className="form-label">Status</label>
                      <RSelect options={status} onChange={(e) => setFormData({ ...formData, status: e.value })} /> */}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit Currency</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Currency Name</label>
                      <input
                        type="text"
                        name="name"
                        defaultValue={formData.name}
                        placeholder="Currency Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        // ref={register({
                        //   required: "This field is required",
                        // })}
                      />
                      {/* {errors.name && <span className="invalid">{errors.name.message}</span>} */}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        defaultValue={statusOptions.find((d) => d.value === String(formData.status))}
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        {isLoadBtn ? (
                          <Button color="primary" disabled>
                            <Spinner size="sm">Loading...</Spinner>
                            <span> Loading</span>
                          </Button>
                        ) : (
                          <Button color="primary" size="md" type="submit">
                            Submit
                          </Button>
                        )}
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={modal.delete}
          toggle={() => setModal({ delete: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Delete Currency</h5>
              <div className="mt-4">
                <Button onClick={deleteProductCat} color="danger" size="lg">
                  Delete
                </Button>
                <Button onClick={onFormCancel} className="ml-2" color="secondary" size="lg">
                  Cancel
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};
